import type { PaginatedResponse, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { replaceParams } from "@/app/api/endpoints";
import type {
	ClassGroup,
	CreateClassGroupRequest,
	ListClassGroupsParams,
	UpdateClassGroupRequest,
} from "../types";

const classGroupEndpoints = {
	list: "/api/class-groups",
	create: "/api/class-groups",
	getById: "/api/class-groups/:id",
	update: "/api/class-groups/:id",
	delete: "/api/class-groups/:id",
};

export const classGroupService = {
	async list(params: ListClassGroupsParams): Promise<PaginatedResponse<ClassGroup>> {
		const response = await apiClient.get<PaginatedResponse<ClassGroup>>(classGroupEndpoints.list, {
			params: {
				page: params.page,
				limit: params.limit,
				organizationId: params.organizationId,
			},
		});
		return response.data;
	},

	async getById(id: string): Promise<ClassGroup> {
		const url = replaceParams(classGroupEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<ClassGroup>>(url);
		return response.data.data;
	},

	async create(data: CreateClassGroupRequest): Promise<ClassGroup> {
		const response = await apiClient.post<SuccessResponse<ClassGroup>>(
			classGroupEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateClassGroupRequest): Promise<ClassGroup> {
		const url = replaceParams(classGroupEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<ClassGroup>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(classGroupEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
